import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import AppInput from '../../../../../../common/AppInput';
import AuthorizeCheckbox from '../authorizeThird/AuthorizeCheckbox';
import { schema } from './validation/schema';
import { useChangeProductStyles } from './styles';
import LoadingButton from '../../../../../../common/LoadingButton';
import { bodyTicketProductGenerator } from '../../../../../../../helpers/tickets/TicketsHelper';
import { createTicketNoProduct } from '../../../../../../../redux/actions/TicketActions';
import { validateDateFormat } from '../../../../../../../helpers/DateFormatter';

const GenericChangeForm = ({ ...props }) => {
  const { mobile, motiveId, type, profile, product } = props;
  const classes = useChangeProductStyles({ mobile });
  const [description, setDescription] = useState('');
  const [descriptionValidation, setDescriptionValidation] = useState('');
  const [checked, setChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [helper, setHelper] = useState('0/250');
  const [errorDate, setErrorDate] = useState(false);
  const [successDate, setSuccessDate] = useState(false);
  const [date, setDate] = useState('');
  const [dateValidation, setDateValidation] = useState('');

  const { ticketNoProductStatus } = useSelector((state) => state.ticketReducer);
  const dispatch = useDispatch();

  const handleDescriptionLabel = () => {
    switch (motiveId) {
      case '5':
      case '6': {
        return 'Descríbenos el estado en que llegó tu producto…';
      }
      case '35': {
        return 'Cuéntanos por qué quieres hacer el cambio…';
      }
      default: {
        return 'Descríbenos el inconveniente…';
      }
    }
  };

  const handleLengthInputs = (e) => {
    const { value } = e.target;
    if (value.length <= 250) {
      setDescription(value);
      setHelper(`${value.length}/250`);
    }
  };

  const handleValidation = () => {
    if ('error' in schema.validate({ description })) {
      setDescriptionValidation('error');
      setErrorMessage(schema.validate({ description }).error.message);
    } else {
      setDescriptionValidation('valid');
      setErrorMessage('');
    }
  };

  const handleDate = (e) => {
    setDate(e.target.value);
  };

  const dateFormat = (e) => {
    const { value } = e.target;
    const isValid = validateDateFormat(value);

    setSuccessDate(isValid);
    setErrorDate(!isValid);
    setDateValidation(isValid ? 'valid' : 'error');
  };

  const sendData = () => {
    const dateReceiptProduct =
      motiveId == 5
        ? { fecha_recepcion_producto: date.split('/').reverse().join('-') }
        : {};
    const body = {
      ...dateReceiptProduct,
      ...bodyTicketProductGenerator({
        profile,
        type,
        motiveId,
        product,
        comment: description,
      }),
    };
    dispatch(createTicketNoProduct(body));
  };

  return (
    <React.Fragment>
      {motiveId == 5 && (
        <AppInput
          required
          name="changeProductDateInput"
          label="Fecha de recepción del producto"
          value={date}
          onClick={() => {}}
          onChange={handleDate}
          onBlur={dateFormat}
          success={successDate}
          errorMessage={'Formato de fecha incorrecto'}
          error={errorDate}
          helperText={'DD/MM/AAAA'}
        />
      )}
      <AppInput
        required
        multiline
        name="changeProductDescriptionInput"
        label={handleDescriptionLabel()}
        value={description}
        onClick={() => {}}
        onChange={handleLengthInputs}
        onBlur={handleValidation}
        errorMessage={errorMessage}
        success={descriptionValidation === 'valid'}
        error={descriptionValidation === 'error'}
        helperText={helper}
      />
      <AuthorizeCheckbox
        idComplement="ChangeProduct"
        onCheck={() => setChecked(!checked)}
        disabled={
          motiveId == 5
            ? descriptionValidation !== 'valid' || dateValidation !== 'valid'
            : descriptionValidation !== 'valid'
        }
      />
      <LoadingButton
        name="ChangeProduct"
        text="Enviar"
        disabled={!checked || descriptionValidation !== 'valid'}
        className={classes.sendButton}
        variant="contained"
        color="primary"
        loading={ticketNoProductStatus === 'loading'}
        onClick={sendData}
        data-cy="ChangeProduct"
      />
    </React.Fragment>
  );
};

GenericChangeForm.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
};

export default GenericChangeForm;
